import { Outlet, createFileRoute } from '@tanstack/react-router';
import { Header } from '@/components/site/Header';
import { Footer } from '@/components/site/Footer';

/** The public site's chrome: header, page, footer. Every route under `_site/` renders here. */
export const Route = createFileRoute('/_site')({
  component: SiteLayout,
});

function SiteLayout() {
  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
